import cls from "classnames";
import TranslateAppear from "components/Animation/TranslateAppear";

function VerticalCard({ className, icon, title, description, image, theme }) {
  return (
    <div
      className={cls(
        "flex flex-col rounded-2xl pt-6 w-full max-w-sm lg:max-w-none lg:min-h-[23.75rem] col-span-2 overflow-hidden",
        className
      )}
      style={{ background: theme.cardBackgroundColor, border: `1px solid ${theme.cardBackgroundColor}` }}
    >
        <div className="px-4 flex flex-col gap-2">
            <img src={icon} className="h-7 w-7" />
            <span className="font-bold text-lg md:text-2xl">{title}</span>
            <p className="text-sm md:text-base">{description}</p>
        </div>
        <img src={image.desktop} className="hidden lg:block mt-auto self-center w-full" />
        <img src={image.mobile} className="lg:hidden mt-9 self-center w-full" />
    </div>
  );
}

function HorizontalCard({ className, icon, title, description, image, theme }) {
  return (
    <div
      className={cls("flex rounded-2xl col-span-3 overflow-hidden h-[11.625rem]", className)}
      style={{ background: theme.cardBackgroundColor, border: `1px solid ${theme.cardBackgroundColor}` }}
    >
        <div className="flex flex-col gap-2 py-6 px-4">
            <img src={icon} className="h-7 w-7" />
            <span className="font-bold text-lg md:text-2xl">{title}</span>
            <p className="text-sm md:text-base">{description}</p>
        </div>

        <img src={image.desktop} className="hidden lg:block h-full shrink-0"/>
        <img src={image.mobile} className="lg:hidden h-full shrink-0"/>
    </div>
  );
}

function RectangleCard(props) {
  return <VerticalCard className="col-span-3 row-span-2" {...props} />;
}

function FeaturesSection({ heading, theme, items }) {
  return (
    <section className="px-5 py-9 md:py-[3.75rem] flex flex-col items-center gap-6 md:gap-9 relative">
      <TranslateAppear>
        <h1 className="font-bold text-2xl leading-normal md:text-[2.5rem] text-center">
            {heading}
        </h1>
      </TranslateAppear>
      <div className="hidden w-full max-w-5xl lg:grid grid-cols-6 grid-flow-dense gap-6">
        {items.map((item, idx) => {
          let Card;

          switch (item.type) {
            case FeaturesSection.CARD_TYPES.HORIZONTAL:
              Card = HorizontalCard;
              break;
            case FeaturesSection.CARD_TYPES.VERTICAL:
              Card = VerticalCard;
              break;
            case FeaturesSection.CARD_TYPES.RECTANGLE:
              Card = RectangleCard;
              break;
            default:
              FeaturesSection.CARD_TYPES.VERTICAL;
          }

          return (
            <Card
              key={idx}
              icon={item.icon}
              title={item.title}
              description={item.description}
              image={item.image}
              theme={theme.features}
            />
          );
        })}
      </div>
      <div className="flex flex-col gap-4 lg:hidden">
        {items.map((item, idx) => {
          return (
            <VerticalCard
              key={idx}
              icon={item.icon}
              title={item.title}
              description={item.description}
              image={item.image}
              theme={theme.features}
            />
          );
        })}
      </div>
    </section>
  );
}

FeaturesSection.CARD_TYPES = {
  VERTICAL: "VERTICAL",
  HORIZONTAL: "HORIZONTAL",
  RECTANGLE: "RECTANGULAR",
};

export default FeaturesSection;
